import React from "react";
import PropTypes from "prop-types";

import "features/application/interests/view.scss";

const InterestsView = ({
  interests,
  age,
  // diversity,
  errorAge,
  errorInterest,
  // showDiversity,
  toggleCheck,
  // toggleClass,
  backToPreviousStep,
  sendApiRequest,
}) => (
  <div className="form__content interests__content">
    <h1 className="application__headline interests__headline interests__elongation">
      Interests and Age Range
    </h1>
    <p className="interests__description interests__elongation">
      Prefered age range of members at your events (choose maximum of three):
    </p>

    {age &&
      age.map((age) => (
        <button
          className={`interests__item${
            age.is_selected ? "--checked" : age.id == errorAge ? "--error" : ""
          }`}
          type="button"
          key={age.id}
          data-age={age.id}
          onClick={toggleCheck}
        >
          {age.name}
        </button>
      ))}

    <p className="interests__description interests__elongation">
      You may choose up to 15 interests:
    </p>
    {interests &&
      interests.map((interest) => (
        <button
          className={`interests__item${
            interest.is_selected
              ? "--checked"
              : interest.id === errorInterest
              ? "--error--type--2"
              : ""
          }`}
          type="button"
          key={interest.id}
          data-interest={interest.id}
          onClick={toggleCheck}
        >
          {interest.name}
        </button>
      ))}
    {/*
    <button
      className={showDiversity ? "interests__item--checked" : "interests__item"}
      type="button"
      onClick={toggleClass}
      data-diversitygroup="diversity"
    >
      Diversity
    </button>

    {diversity &&
      diversity.map((diversity) => (
        <button
          className={`interests__item${
            diversity.is_selected ? "--checked" : ""
          }`}
          data-show={showDiversity ? "show" : "hide"}
          type="button"
          key={diversity.id}
          data-diversity={diversity.id}
          onClick={toggleCheck}
        >
          {diversity.name}
        </button>
      ))}
        */}

    <div className="application__buttons interests__elongation">
      <button
        className="application__button"
        type="button"
        onClick={backToPreviousStep}
      >
        Back
      </button>
      <button
        className="application__button"
        type="submit"
        onClick={sendApiRequest}
      >
        Next
      </button>
    </div>
  </div>
);

InterestsView.propTypes = {
  interests: PropTypes.array,
  age: PropTypes.array,
  diversity: PropTypes.array,
  errorAge: PropTypes.number,
  errorInterest: PropTypes.number,
  toggleCheck: PropTypes.func,
  toggleClass: PropTypes.func,
  backToPreviousStep: PropTypes.func,
  showDiversity: PropTypes.bool,
  sendApiRequest: PropTypes.func,
};

export default InterestsView;
